// Le catalogue des territoires (12 octobre 2026).
export default {
  titre: 'Catalogue',
  sousTitre: 'Tous les territoires d’Orion · {n} dans votre radar',
  sousTitreAucun: 'Tous les territoires d’Orion',
  chargement: 'Lecture du catalogue…',
  erreur: 'Le catalogue ne s’est pas chargé.',
  reessayer: 'Réessayer',
  fermer: 'Fermer',
  recherche: 'Chercher un territoire',
  rechercheAria: 'Chercher un territoire par son nom',
  vue: { aria: 'Quels territoires', tous: 'Tous', radar: 'Dans mon radar', disponibles: 'À ajouter' },
  familles: {
    aria: 'Les familles',
    toutes: 'Toutes',
    pays: 'Pays',
    regions: 'Régions et villes',
    continents: 'Continents',
    chaines: 'Chaînes',
    plateformes: 'Plateformes et réseaux',
    thematiques: 'Thématiques',
    jeunes: 'Publics jeunes',
    electorats: 'Électorats',
  },
  dispo: { suivi: 'Suivi chaque jour', sous_24h: 'Prêt sous 24 h', sur_demande: 'Sur demande' },
  tailleInconnue: 'Taille non publiée',
  recoupe: 'Recoupe {pct} % avec {nom}',
  legende: 'Recoupement : la proximité avec ce que vous suivez déjà, deux publics qui parlent des mêmes sujets.',
  ajouter: 'Ajouter à mon radar',
  ajout: 'Ajout…',
  dansRadar: 'Dans votre radar',
  retirer: 'Retirer',
  retirerAria: 'Retirer {nom} de mon radar',
  ajouterAria: 'Ajouter {nom} à mon radar',
  ouvertParOrion: 'Ouvert par l’équipe Orion',
  surDemande: 'L’équipe Orion ouvre les électorats sur demande.',
  toutVoir: 'Voir les {n} territoires',
  moins: 'Afficher moins',
  aucun: 'Aucun territoire ne correspond.',
  ajoute: {
    suivi: '{nom} est dans votre radar.',
    patrouille: '{nom} est dans votre radar : ses premières lectures arrivent demain matin.',
    synthese: '{nom} est dans votre radar : Orion le prépare, il sera prêt sous 24 h.',
    sans_fuseau: '{nom} est dans votre radar : l’équipe Orion termine sa mise en route.',
  },
  retire: '{nom} a quitté votre radar.',
}
